import { Card, CardContent } from "@/components/primitives";
import { Lightbulb } from "lucide-react";

interface EmptyStateProps {
	show: boolean;
}

export function EmptyState({ show }: EmptyStateProps) {
	if (!show) {
		return null;
	}

	return (
		<Card className="border-2 shadow-xl bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm">
			<CardContent className="text-center py-8">
				<div className="p-3 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600 w-fit mx-auto mb-4">
					<Lightbulb className="h-8 w-8 text-white" />
				</div>
				<h3 className="text-lg font-semibold text-foreground mb-2">
					Reflection in Progress
				</h3>
				<p className="text-muted-foreground">
					This reflection doesn't have detailed analysis yet.
				</p>
			</CardContent>
		</Card>
	);
}
